import { Maximize2, Minimize2 } from "lucide-react";

// Expand / shrink control placed beside a dialog's close (X) button.
export const DialogExpandToggle = ({ expanded, onToggle, testId, className = "" }) => (
  <button
    type="button"
    onClick={onToggle}
    className={`${className} absolute right-11 top-4 rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-600`}
    title={expanded ? "Shrink window" : "Expand window"}
    aria-label={expanded ? "Shrink window" : "Expand window"}
    data-testid={testId}
  >
    {expanded ? <Minimize2 className="h-4 w-4" /> : <Maximize2 className="h-4 w-4" />}
  </button>
);

export const EXPANDED_DIALOG_CLASSES = "!max-w-[95vw] !w-[95vw] !h-[95vh] !max-h-[95vh]";
